import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Store } from '@ngrx/store'
import { AppState } from "../../reducers";
import { SeatingplanSaleActions } from "./seatingplan-sale.actions";
import { EventApi, CategoryApi, VenueApi, TicketQuotaApi, SeatingplanApi } from "../../services/webservice";
import { EventActions, VenueActions, CategoryActions, TicketQuotaActions, SeatingplanServerActions } from "../../actions"
import { PriceLevelService } from "../../services"

@Injectable()
export class SeatingplanResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private eventApi: EventApi,
		private eventActions: EventActions,
		private venueActions: VenueActions,
		private categoryActions: CategoryActions,
		private ticketQuotaActions: TicketQuotaActions,
		private categoryApi: CategoryApi,
		private venueApi: VenueApi,
		private ticketQuotaApi: TicketQuotaApi,
		private priceLevelService: PriceLevelService,
		private seatingplanApi: SeatingplanApi,
		private seatingplanServerActions: SeatingplanServerActions
	) { }

	public loadFullEvent(eventId: string) {
		this.store.dispatch(this.eventActions.clearState())
		this.store.dispatch(this.venueActions.clearState())
		this.store.dispatch(this.categoryActions.clearState())
		this.eventApi.getEventById(eventId).subscribe(event => {
			this.store.dispatch(this.eventActions.eventLoaded(event))
			this.venueApi.getVenueById(event.venueId.toString()).subscribe(venue => this.store.dispatch(this.venueActions.venueLoaded(venue)))
			this.categoryApi.getCategories(event._links.categories.href).subscribe(categories => {
																			this.store.dispatch(this.categoryActions.loadCollectionSuccess(categories))
																			this.priceLevelService.loadPriceLevels(categories)
			})

			this.seatingplanApi.loadSeatingplanByUuid(event.seatingplanUuid).subscribe(seatingplan => {
				this.store.dispatch(this.seatingplanServerActions.seatingplanLoaded(seatingplan));
			});

			this.ticketQuotaApi.getTicketQuotas(event._links.ticketQuotas.href)
				.subscribe(ticketQuotas => this.store.dispatch(this.ticketQuotaActions.loadCollectionSuccess(ticketQuotas)))
		})
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
		const eventId = route.params["id"]
		this.loadFullEvent(eventId);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/seatingplan-sale/seatingplan-sale.resolver.ts